import {
	normalize,
	escapeHtml,
	parseQuery,
	highlightJQ,
	unhighlightJQ,
	smoothScrollTo,
	debounce,
} from "../../utils";

export function initAccordionSearch() {
	const host = document.getElementById("accordion-search");
	if (!host) return;
	if (typeof window.jQuery === "undefined") {
		console.warn("[MagicTools] jQuery not found; accordion search disabled.");
		return;
	}
	const $ = window.jQuery;

	// ---------- Sélecteurs ----------
	const ACC_SELECTOR = ".wp-block-brblocks-accordion";
	const TITLE_SELECTOR = ".accordion-title";
	const CONTENT_SELECTOR = ".accordion-content";
	const OPEN_CLASS = "open";               // ← was "is-open"
	const TABS_BLOCK = ".wp-block-brblocks-tabs";
	const TABS_CONTENT = ".tab-content";
	const TABS_BTNS_WRAP = '[data-tabs="buttons"]';
	const TABS_BTN = ".tab-button";
	const getAccordions = () => $(ACC_SELECTOR);
	const $tabsBlocks = $(TABS_BLOCK);

	const mq = window.matchMedia("(max-width: 760px)");

	// ---------- Accordéons (aligned with accordion block's own view.js) ----------
	function openAccordion($acc, open) {
		const acc = $acc[0];
		if (!acc) return $acc.find(CONTENT_SELECTOR);

		const content = acc.querySelector(CONTENT_SELECTOR);
		const title = acc.querySelector(TITLE_SELECTOR);

		if (open) {
			acc.classList.add(OPEN_CLASS);
			if (content) {
				content.classList.add(OPEN_CLASS);
				if (mq.matches) {
					content.style.maxHeight = content.scrollHeight + "px";
				}
			}
			if (title) {
				title.classList.add("active");
				title.setAttribute("aria-expanded", "true");
			}
			// Also make sure the wrapper is visible (search may have hidden it)
			acc.style.display = "";
		} else {
			acc.classList.remove(OPEN_CLASS);
			if (content) {
				content.classList.remove(OPEN_CLASS);
				if (mq.matches) {
					content.style.maxHeight = "0px";
				}
			}
			if (title) {
				title.classList.remove("active");
				title.setAttribute("aria-expanded", "false");
			}
		}
		return $(content);
	}

	// ---------- Tabs ----------
	function flattenAllTabs() {
		$tabsBlocks.each(function () {
			const $block = $(this);
			$block.find(TABS_CONTENT).css("display", "block");
			$block.find(TABS_BTNS_WRAP).hide();
			$block.find(TABS_BTN).removeClass("active").attr("aria-selected", "false");
		});
	}
	function restoreTabsInitial() {
		$tabsBlocks.each(function () {
			const $block = $(this);
			const $contents = $block.find(TABS_CONTENT);
			const $btnsWrap = $block.find(TABS_BTNS_WRAP).first();
			const $btns = $btnsWrap.find(TABS_BTN);
			let active = 0;
			$contents.each(function (i) {
				if ($(this).css("display") !== "none") { active = i; return false; }
			});
			$contents.each(function (i) {
				$(this).css("display", i === active ? "block" : "none");
			});
			if ($btnsWrap.length) {
				$btnsWrap.show();
				$btns.removeClass("active").attr("aria-selected", "false");
				if ($btns.get(active))
					$($btns.get(active)).addClass("active").attr("aria-selected", "true");
			}
		});
	}

	// ---------- États init ----------
	const initialAccState = new Map();
	(function tagAndMemorize() {
		let counter = 0;
		getAccordions().each(function () {
			const $acc = $(this);
			if (!$acc.attr("data-acc-id")) $acc.attr("data-acc-id", "acc-" + ++counter);
			const isOpen = $acc.hasClass(OPEN_CLASS);
			initialAccState.set(this, isOpen);
		});
	})();

	// ---------- UI initiale ----------
	function renderInitialMessage() {
		let terms = ["Academia", "Associates", "Sector Members"];
		const raw = host.getAttribute("data-quick-terms") || "";
		const parsed = raw.split(";").map((s) => s.trim()).filter(Boolean);
		if (parsed.length) terms = parsed;
		const chips = terms
			.map(
				(t) =>
					`<span class="quick-term" role="button" tabindex="0" data-term="${escapeHtml(t)}">${escapeHtml(t)}</span>`
			)
			.join("");
		$("#accordionResults").html(`
			<div class="muted">
				Most Searched Terms:
				<span class="quick-terms">${chips}</span>
			</div>
		`);
	}

	// Clear button
	function ensureClearButton() {
		if (
			!document.getElementById("accordionClear") &&
			document.getElementById("accordionQuery")
		) {
			$("#accordionQuery").after(`
				<button id="accordionClear" type="button" class="clear-btn" title="Clear search" aria-label="Clear search" style="display:none;">
					<span aria-hidden="true">✖</span>
				</button>
			`);
		}
	}
	ensureClearButton();
	const mo = new MutationObserver(() => ensureClearButton());
	mo.observe(host, { childList: true, subtree: true });

	// ---------- Snippet ----------
	function makeSnippet(htmlEl, termRegexes, radius = 80) {
		const text = $(htmlEl).text();
		const norm = normalize(text);
		let firstHit = -1;
		termRegexes.forEach((rx) => {
			rx.lastIndex = 0;
			const m = norm.match(rx);
			if (m) {
				const idx = norm.indexOf(m[0]);
				if (idx !== -1 && (firstHit === -1 || idx < firstHit)) firstHit = idx;
			}
		});
		if (firstHit === -1) return null;
		const start = Math.max(0, firstHit - radius);
		const end = Math.min(text.length, firstHit + radius);
		let snHtml = text.slice(start, end);
		termRegexes.forEach((rx) => {
			rx.lastIndex = 0;
			snHtml = snHtml.replace(rx, (m) => `<mark class="search-hit">${m}</mark>`);
		});
		return (start > 0 ? "…" : "") + snHtml + (end < text.length ? "…" : "");
	}

	// ---------- Build regexes ----------
	function buildRegexes(q) {
		return parseQuery(q).map(
			(t) => new RegExp(normalize(t).replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "gi")
		);
	}

	// ---------- Highlight after open (with small delay for CSS transition) ----------
	function highlightAfterOpen(items, termRegexes) {
		// Small delay to let max-height transition reveal content
		setTimeout(() => {
			items.forEach(({ $title, $content }) => {
				unhighlightJQ($title);
				unhighlightJQ($content);
				highlightJQ($title, termRegexes);
				highlightJQ($content, termRegexes);
			});
		}, 50);
	}

	// ---------- Handler ----------
	const onSearch = debounce(function () {
		const q = $("#accordionQuery").val()?.trim() || "";
		const $results = $("#accordionResults");
		$("#accordionClear").toggle(!!q);

		getAccordions().each(function () {
			const $acc = $(this);
			unhighlightJQ($acc.find(TITLE_SELECTOR));
			unhighlightJQ($acc.find(CONTENT_SELECTOR));
		});

		if (!q) {
			restoreTabsInitial();
			getAccordions().each(function () {
				const $acc = $(this);
				$acc.css("display", "");  // show all
				const wasOpen = initialAccState.get(this);
				openAccordion($acc, !!wasOpen);
			});
			renderInitialMessage();
			return;
		}

		flattenAllTabs();

		const termRegexes = buildRegexes(q);
		const matches = [];
		const toHighlight = [];

		getAccordions().each(function () {
			const $acc = $(this);
			const $title = $acc.find(TITLE_SELECTOR).first();
			const $content = $acc.find(CONTENT_SELECTOR).first();
			const hayAll = normalize($title.text()) + "\n" + normalize($content.text());
			const hit = termRegexes.some((rx) => { rx.lastIndex = 0; return rx.test(hayAll); });
			termRegexes.forEach((rx) => (rx.lastIndex = 0));

			if (hit) {
				$acc.css("display", "");  // show
				openAccordion($acc, true);
				toHighlight.push({ $title, $content });
				const snippet =
					makeSnippet($content[0], termRegexes) ||
					makeSnippet($title[0], termRegexes) ||
					"";
				matches.push({
					accId: $acc.attr("data-acc-id") || "",
					titleHtml: $title.html(),
					snippetHtml: snippet,
				});
			} else {
				openAccordion($acc, false);
				$acc.css("display", "none");  // hide
			}
		});

		if (!matches.length) {
			$results.html('<div class="muted">Sorry, no results were found.</div>');
		} else {
			$results.html(
				[
					`<div><strong>${matches.length}</strong> result(s) :</div>`,
					matches
						.map(
							(m) => `
					<div class="res-item">
						<a href="#" class="res-title" data-acc-id="${m.accId}">${m.titleHtml}</a>
						${m.snippetHtml ? `<span class="res-snippet">${m.snippetHtml}</span>` : ""}
					</div>`
						)
						.join(""),
				].join("")
			);
		}

		// Highlight after CSS transition has had time to open
		highlightAfterOpen(toHighlight, termRegexes);
	}, 200);

	// ---------- Events ----------
	$(document).off("input.mtSearch").on("input.mtSearch", "#accordionQuery", onSearch);

	$(document).off("click.mtClear").on("click.mtClear", "#accordionClear", function () {
		$("#accordionQuery").val("");
		$(this).hide();
		onSearch();
	});

	$(document).off("keydown.mtEsc").on("keydown.mtEsc", "#accordionQuery", function (e) {
		if (e.key === "Escape") $("#accordionClear").trigger("click");
	});

	// Click result → open + highlight + scroll
	$(document)
		.off("click.mtResult")
		.on("click.mtResult", "#accordionResults .res-title", function (e) {
			e.preventDefault();
			const accId = $(this).data("acc-id");
			if (!accId) return;
			flattenAllTabs();
			const $acc = $(`${ACC_SELECTOR}[data-acc-id="${accId}"]`).first();
			if (!$acc.length) return;

			const q = $("#accordionQuery").val()?.trim() || "";
			const termRegexes = buildRegexes(q);
			const $title = $acc.find(TITLE_SELECTOR).first();

			openAccordion($acc, true);

			// Highlight + scroll after CSS transition
			setTimeout(() => {
				const $content = $acc.find(CONTENT_SELECTOR).first();
				unhighlightJQ($title);
				unhighlightJQ($content);
				highlightJQ($title, termRegexes);
				highlightJQ($content, termRegexes);
				const firstMark = $acc.find("mark.search-hit").get(0);
				smoothScrollTo(firstMark || $acc.get(0));
			}, 100);
		});

	// Quick terms
	function addTermToInput(term) {
		const $input = $("#accordionQuery");
		const cur = $input.val()?.trim() || "";
		const tokens = cur ? parseQuery(cur) : [];
		const quoted = `"${term}"`;
		if (!tokens.includes(term) && !tokens.includes(quoted)) tokens.push(quoted);
		$input.val(tokens.join(" ")).trigger("input").focus();
	}

	$(document)
		.off("click.mtQuick keypress.mtQuick", "#accordionResults .quick-term")
		.on(
			"click.mtQuick keypress.mtQuick",
			"#accordionResults .quick-term",
			function (e) {
				if (e.type === "keypress" && e.which !== 13 && e.which !== 32) return;
				e.preventDefault();
				const term = $(this).data("term");
				if (!term) return;
				addTermToInput(term);
			}
		);

	if (!$("#accordionResults").children().length) renderInitialMessage();
}